import { signalStoreFeature, withComputed } from '@ngrx/signals';
import { IAgentStore } from './agent.public';

export function withAgents(agentStore: IAgentStore) {
    return signalStoreFeature(
        withComputed(() => ({
            agents: agentStore.agents,
        })),
    );
}
